// group.js
// A group of item components (item.js)
// TODO: group level show / hide handling. Use item level flag for now.

import React from 'react'
import traverse from 'traverse'
import {cloneDeep, get} from 'lodash'

import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import * as Actions from './redux/actions'
import Item from './item.js'

class Group extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      id            : this.props.id,
      schema        : this.props.schema,
      show          : get(this.props, 'show', true),
      collapsable   : get(this.props, 'collapsable', false),
      collapsed     : false,
      removable     : get(this.props, 'removable', false),
      // if group is named 'actions', no style class names like 'panel panel-default' are assigned
      classes       : get(this.props, 'classes') || (this.props.id.match(/^action.*/i) ? '' : get(this.props,'AXGClasses.group', 'panel panel-default')),
      classesHeader : get(this.props, ['AXGClasses','group.header'], 'panel-heading'),
      // classesBody   : get(this.props, ['AXGClasses','group.body'], 'panel-body'),
      classesBody   : get(this.props, 'schema.classes', 'panel-body'),
      classesFooter : get(this.props, ['AXGClasses','group.footer'], 'panel-footer'),
    }
  }

  handleRemoveGroup() {
    // console.log(`TODO: handleRemoveGroup: ${this.props.AXGKey}`)
    var updatedSchema = cloneDeep(this.props.appSchema)
    // console.log(`updatedSchema: ${JSON.stringify(updatedSchema)}`)
    var viewId = this.props.AXGKey.split('.')[0]
    var groupId = this.props.AXGKey.split('.')[1]
    // console.log(`viewId / groupId: ${viewId} / ${groupId}`)
    // var groupLayout = get(updatedSchema, `views.${viewId}.groups.layout`)
    // console.log(`layout: ${JSON.stringify(groupLayout)}`)
    updatedSchema = traverse(updatedSchema).map(function(node){
      if (this.key === groupId) {
        this.delete()
      }
    })
    this.props.actions.setSchema({schema: updatedSchema})
  }

  handleToggleGroup() {
    this.setState({
      collapsed: !this.state.collapsed
    })
  }

  render() {
    const {id, schema : items } = this.state
    // const id = this.state.id
    // const items = this.state.schema
    let orderedSections = []
    if (items) {
      orderedSections = [
        {
          type    : 'header',
          key     : `header-${id}`,
          classes : this.state.classesHeader,
          items   : items.filter( (i) => Object.keys(i)[0]==='header' ),
        },
        {
          type    : 'body',
          key     : `body-${id}`,
          classes : this.state.classesBody,
          items   : items.filter( (i) => Object.keys(i)[0]!=='header' && Object.keys(i)[0]!=='footer' ),
        },
        {
          type    : 'footer',
          key     : `footer-${id}`,
          classes : this.state.classesFooter,
          items   : items.filter( (i) => Object.keys(i)[0]==='footer' ),
        },
      ]
    }
    return (
      // group classes
      // <div className={`${this.state.classes}${this.state.show ? '' : ' hidden'}`}>
      // REVIEW: use state or props for dynamic update ?
      <div className={
              this.state.classes +
              ( get(this.props, 'show', true) ? '' : ' hidden' )
            }>
        {
          orderedSections.map(
            (section) => {
              return (
                (section.items.length > 0) &&
                  <div key={section.key} className={
                        section.classes +
                        ( section.type == 'body' && this.state.collapsed ? ' hidden' : '' )
                      }>
                    {
                      (this.state.removable && section.type == 'header') &&
                        <button type="button" className="close" aria-hidden="true" onClick={this.handleRemoveGroup.bind(this)}>
                          <i className="material-icons">remove_circle_outline</i>
                        </button>
                    }
                    {
                      (this.state.collapsable && section.type == 'header') &&
                        <button type="button" className="close" aria-hidden="true"
                            onClick={this.handleToggleGroup.bind(this)}>
                          <i className="material-icons">
                            {
                              this.state.collapsed
                              ? 'keyboard_arrow_down'
                              : 'keyboard_arrow_up'
                            }
                          </i>
                        </button>
                    }
                    {
                      section.items.map( (item) => {
                        var itemKey = Object.keys(item)[0]
                        return (
                            <Item
                              env={this.props.env}
                              key={`${this.props.AXGKey}.${itemKey}`}
                              id={itemKey}
                              account={this.props.account}
                              AXGKey={`${this.props.AXGKey}.${itemKey}`}
                              schema={item[itemKey]}
                              AXGClasses={this.props.AXGClasses}
                              AXGOptions={this.props.AXGOptions}
                              AXGDataSource={this.props.AXGDataSource}/>
                        )
                      })
                    }
                  </div>
              )
            }
          )
        }
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    appSchema : state.AXGSchema.schema,
    appxigonState: state.AXGState,
  }
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Group)



// WEBPACK FOOTER //
// ./group.js